<template>
    <div class="appHomeSetWrap">
        <div class="oneBlock">
            <div class="blockTitle">生产商</div>
            <div class="blockContent">
                <div class="switchBox">
                    <span class="label">订货模块</span>
                    <el-switch  v-model="infoObj.manufacturer_order_conference_switch" active-value="y"    inactive-value="n" @change="changeValue($event,'manufacturer_order_conference_switch')">  </el-switch>
                    <span>{{infoObj.manufacturer_order_conference_switch |turnToWordBoolue}}</span>
                    
                    
                </div>
                <!-- <div class="inputBox">
                    <span class="label">活动链接入口</span>
                    <input type="text" placeholder="请输入内容">
                    <span class="addIcon"> <i class="el-icon-circle-plus"></i> </span>
                </div>

                <div class="switchBox">
                    <span class="label">包工包料</span>
                    <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </div> -->

            </div>
        </div>

        <div class="oneBlock">
            <div class="blockTitle">品牌</div>
            <div class="blockContent">
                <div class="switchBox">
                    <span class="label">订货模块</span>
                    <el-switch v-model="infoObj.brand_order_conference_switch"  active-value="y"    inactive-value="n" @change="changeValue($event,'brand_order_conference_switch')">  </el-switch>
                    <span>{{infoObj.brand_order_conference_switch |turnToWordBoolue}}</span>

                </div>
                <!-- <div class="inputBox">+
                    <span class="label">活动链接入口</span>
                    <input type="text" placeholder="请输入内容">
                    <span class="addIcon"> <i class="el-icon-circle-plus"></i> </span>
                </div>

                <div class="switchBox">
                    <span class="label">包工包料</span>
                    <el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                </div> -->

            </div>
        </div>

        <div class="des">根据不同身份，默认设置选择显示不同服务模块</div>




    </div>
</template>

<script>
    // import {json,wordData,utils} from '@/common/common.js'
    import {
        api,
        ajaxPost
    } from '@/common/request.js'
    export default {
        name: 'HelloWorld',
        data() {
            return {
                infoObj:{
                    manufacturer_order_conference_switch:'',
                    brand_order_conference_switch:''
                }
            }
        },
        filters: {
            turnToWordBoolue: function(value) {
                let result=""
                if(value=='y'){
                    result= "开";
                }else if(value=='n'){
                    result= "关";
                }else{
                    result= "-"
                }
                return result
                
            }
        },
        methods: {
            getInfo(){
                let _this=this
                let arg={
                    showType:1 //1=app首页设置  2=认证短信设置   3=服务费设置
                }
                ajaxPost('/app/showAppConfigInfo',arg).then(function(res) {
                    if(res.errorCode==200&&res.data){
                        res.data.forEach(function(item,index){
                            let keyword=item.config_name
                            _this.infoObj[keyword]=item.config_value
                        })
                    }
                    
                }, function(res) {
                })
            },
            changeValue($event,keyword){
                let _this=this
                console.log($event)
                console.log(keyword)
                if(confirm("确认修改该项开关吗？")){
                    let arg={
                        "showType":1,
                        "configValue":$event,
                        "configName":keyword
                    }
                    ajaxPost('/app/updateConfigInfoByType',arg).then(function(res) {
                        if(res.errorCode==200){
                            _this.$message({
                                message: "修改成功", 
                                type: 'success',
                                duration: 1500
                            });
                        }
                        
                    }, function(res) {
                    })
                    
                }else{
                    setTimeout(function(){
                        if($event=='y'){
                            _this.infoObj[keyword]='n'
                        }
                        if($event=='n'){
                            _this.infoObj[keyword]='y'
                        }
                    },100)
                    return false
                }
            }
        },
        mounted() {
            this.getInfo()
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .appHomeSetWrap {
        input{border-radius: 4px ;border:1px solid #aaa;padding:5px 10px;}
        .oneBlock {
            border:1px solid #ddd; border-radius: 6px; padding:20px 10px; margin:10px;  background: #fff; box-shadow: 0 3px 10px #ccc;
            .blockTitle {
                background: lightblue; padding:10px;
                
            }

            .blockContent {
               
                padding:10px;
                 .label{display: inline-block;width: 120px;}
                .switchBox{ padding:10px 0;}
                .inputBox{}
                .addIcon{padding:10px;background: aliceblue;color:blue;cursor: pointer;}
                .addIcon:hover{background: skyblue}
            }
        }
        .des{padding:10px;color: blueviolet;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/appPage/appHomeSet.vue